module.exports = __webpack_public_path__ + "static/banner_medium-3129427de0b456bbf481630912193338.png";